import styled from 'styled-components';
import {dFlex, dFlexColumn, flexWrap} from '../../../../../../globalVariables/GlobalFlex';
import {getToken, getSpacing, getFontSize, tokens} from '@tickchak/react-share/app';
import {popUpBody} from '../../../../../../component/newPopup/mobilePopup/MobilePopup.css';
import {tooltip} from '../../../../../../component/tooltip/tooltipAbsolute/TooltipAbsolute.css';

export const categorySection = styled.div`
    ${dFlexColumn}
    gap: ${getSpacing('spaceLg')};
    width: 100%;
    position: relative;
`;

export const categoryLabel = styled.div`
    ${dFlex};
    gap: ${getSpacing('spaceXs')};
    color: ${getToken('color.text.secondary')};
    font-size: ${getFontSize('caption')};
    position: relative;
    
    ${tooltip} {
        width: 13px;
        height: 13px;
        padding: 0;
        background-size: 13px 8px;
        border-radius: 50%;
        background-position: center;
        // Hardcoded color - no matching token in @tickchak/react-share
        background-color: #DD2F21;
        position: absolute;
        inset-inline-end: 0;
    }
`;

export const categoriesWrapper = styled.div`
    ${dFlex}
    ${flexWrap}
    gap: ${getSpacing('spaceSm')};
    width: 100%;
    padding: ${getSpacing('spaceLg')};
    background: ${tokens.primitives.grays.gray100};
    border-radius: ${getSpacing('spaceMd')};
`;

export const addCategoryPopupWrapper = styled.div`
    ${popUpBody} {
        min-height: 240px;
        height: 240px;
        max-height: 240px;
    }
`;

